<v-container class="pa-0 help-container" fluid>
  <!-- :color="aiChatBotKeys?.BackgroundColor" -->
  <div class="bg-home-banner position-fixed left-0 top-0 z-index-n1 w-100 h-50 bg-banditai">

  </div>
  <v-card class="rounded-0 overflow-auto bg-transparent" style="height: calc(100vh - 54px);" flat>
    <!-- Header Section -->
    <!-- <div class="mb-1 text-end">
      <v-btn
        variant="text"
        size="40"
        @click="$emit('closeDialog','Close')"
        rounded
        aria-label="Close chat box"
        color="white"
      >
        <v-icon class="fs-24px" role="img" aria-hidden="true"
          >mdi mdi-close-circle</v-icon
        >
      </v-btn>
    </div> -->
    <v-card  flat tile class="z-index-99 bg-transparent position-relative">
      <v-card-text class="pt-4 pb-0">
        <v-card
          flat
          class="overflow-visible bg-transparent mb-1  d-flex align-center justify-space-between bg-transparent"
        >
          <div class="fs-20px font-weight-semibold lh-1 text-white"
          :class="aiChatBotKeys?.ProductName?.toLowerCase()?.includes('tax990') ? 'd-flex' : ''"
          >
            {{  greeting.greetingName }},&nbsp;
             <div class="font-weight-regular">{{greeting.greetingDescription}}</div>
          </div>
          <v-btn
          variant="text"
          size="40"
          @click="$emit('closeDialog','Close')"
          style="background-color: rgba(0, 0, 0, 0.2); transition: background-color 150ms; position: fixed; right: 20px;"
          rounded
          aria-label="Close chat box"
          color="white"
        >
          <v-icon class="fs-24px" role="img" aria-hidden="true"
            >mdi mdi-close-circle</v-icon
          >
        </v-btn>
        </v-card>
        <!-- <p class="fs-26px font-weight-medium text-white lh-1">
          {{greeting.greetingDescription}}
        </p> -->

        <!-- Search/Question Box -->
        <!-- 
        <v-text-field
          placeholder="Ask a question"
          variant="outlined"
          hide-details="auto"
          density="compact"
          ref="inputField"
          readonly
          class="text-grey rounded"
          @click="navigateToOther('AIChatBot')"
        >
          <template v-slot:append-inner>
            <v-icon class="ms-2 text-black opacity-1">mdi-chevron-right</v-icon>
          </template>
        </v-text-field> -->
      </v-card-text>
    </v-card>
    <v-card-text class="pa-4">
      <!-- Featured Content Card -->
      <div v-if="!isPageLoader">
        <v-card flat class="overflow-visible"  v-if="aiChatBotKeys?.IsChat">
          <v-card class="overflow-visible shadow-lg"  v-if="Object.keys(chatConversationHistory??{}).length !=0">
            <v-card-title class="d-flex align-center justify-space-between fs-14px pt-3 pb-2">
              Recent Chat
            
            </v-card-title>
         
            <v-card-text>
         
              <div class="d-flex align-start">
                <div class="d-flex align-center">
                <v-img
                 :src="aiChatBotKeys?.ProductName?.toLowerCase()?.includes('tax990') ? tax990ChatWithUS : BotIconPath"
                  alt="Bandit AI"
                  width="45"
                  max-width="45"
                  v-if="aiChatBotKeys?.ProductName?.toLowerCase()?.includes('tax990') ? tax990ChatWithUS : BotIconPath"
                ></v-img>
                <div class="w-50px"  v-else>
                  <ChatStarIcon></ChatStarIcon>
                </div>
                <div class="ms-3">
                  <p class="fs-14px text-black lh-18px text-truncate w-240px">
                    {{chatConversationHistory.Title}} 
                  </p>
                  <p class="fs-12px font-weight-light text-grey">{{formatTime(chatConversationHistory.LastUpdated)}}</p>
                </div>
              </div>
              <v-btn variant="text" icon color="black" size="30" class="mt-1" @click="navigateAndShowExistingChat(chatConversationHistory)">
                <v-icon role="img">mdi-chevron-right</v-icon>
              </v-btn>
              </div>
            </v-card-text>
          </v-card>
          <v-card v-else >
            <v-card  @click="navigateToOther('AIChatBot')">
              <v-card-text class="d-flex justify-space-between align-center pa-0 py-2 px-4">

                <div class="d-flex align-center">
                  <v-img  v-if="aiChatBotKeys?.ProductName?.toLowerCase()?.includes('tax990') ? tax990ChatWithUS : BotIconPath" :src="aiChatBotKeys?.ProductName?.toLowerCase()?.includes('tax990') ? tax990ChatWithUS : BotIconPath" alt="Bandit Icon" width="30" max-width="30"></v-img>
                  <div class="w-50px"  v-else>
                    <ChatStarIcon></ChatStarIcon>
                  </div>
                  <span class="font-weight-medium ms-3">Chat with Agent</span>
                 
                </div>
                <v-icon class="ms-2 text-black opacity-1"
                >mdi-chevron-right</v-icon
              >
              </v-card-text>
            </v-card>
           
          </v-card>
        </v-card>

        <v-card flat class="overflow-visible bg-transparent" v-if="!isWealthRabbit">
          <v-card
            @click="openArticleAnswer(item)"
            flat 
            v-for="(item,index) in pageDetailArticles"
            :key="index"
            v-if="pageDetailArticles?.length"
            class="mt-4 mb-4 overflow-visible  card-shadow border border-disable border-opacity-100"
          >
            <!-- <v-card-title class="py-3">
              <v-img :src="aiChatBotKeys.HomeFeedImageUrl" alt="Image Blocked"></v-img>
            </v-card-title> -->
            <!-- <v-divider></v-divider> -->
            <v-card-text class="pa-4 pt-3 pb-1 chatai">
              <p class="text-black font-weight-medium lh-18px mb-1">
               {{item.Question}}
              </p>
              <p class="text-grey font-weight-regular lh-18px" style=" cursor: pointer; " v-html="item.Answer?.split('\n')[0]"></p>
               
            </v-card-text>
            <div class="text-end px-3 mb-3">
              <v-btn    @click="openArticleAnswer(item)" color="primary" variant="text" class="text-initial mb-3 border-0 fs-14px"  >  Read More <v-icon class="ms-1">mdi-chevron-right</v-icon> </v-btn>

            </div>
          </v-card>



          <v-card
          flat 
          v-for="(item,index) in videoReference"
          :key="index"
          class="mt-4 mb-4 overflow-visible  card-shadow border border-disable border-opacity-100"
        >
          <v-card-title class="py-3">
            <embed
              width="100%"
              height="200"
              :src="item.VideoUrl"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></embed>     
          </v-card-title>
          <!-- <v-divider></v-divider> -->
          <v-card-text class="pa-4 py-3" >
            <!-- <p class="text-black lh-18px mb-1">
            {{item.VideoName}}
            </p> -->
            <p class="text-grey  lh-18px">{{item.VideoDescription}}</p>
          </v-card-text>
        </v-card>

         <v-card>

              <v-text-field variant="outlined"    @click="IsFocusSearch=true,navigateToOther(),HelpArticleId=''" density="compact" placeholder="Search for help..." class="ma-4 cursor-pointer" flat  hide-details append-inner-icon="mdi-magnify"/>
               
          
         
            <v-divider color="disable opacity-1"></v-divider>
            <v-card-text class="px-4 py-2">
              <v-list density="compact" class="py-0">
              <v-list-item
                class="pe-2"
                v-for="(collection, index) in helpQuestionsAns"
                :key="collection.id"
                @click="openArticleAnswer(collection)"
              >
                <v-list-item-title>
                  <p
                    id="helpquestion"
                    class="fs-14px text-black font-weight-medium mb-1 text-truncate"
                  >
                    {{collection.Question}}
                  </p>
                  <v-tooltip
                   v-if="ActiveComponent == 'Home'"
                  activator="parent"
                  location="bottom"
                >{{collection.Question}}</v-tooltip>
                </v-list-item-title>
                <template v-slot:prepend>
                  <span class="TBS-Star fs-16px me-1 text-grey"></span>
                </template>
                <template v-slot:append>
                  <v-btn
                    color="grey"
                    icon="mdi-chevron-right"
                    variant="text"
                    size="28"
                  ></v-btn>
                </template>
              </v-list-item>
            </v-list>
            </v-card-text>
  
            <v-card-actions class="justify-end me-3"  v-if="helpQuestionsAns?.length>0">
              <v-btn
              
                @click="viewAllArticle()"
                color="primary"
                class="text-initial fs-14px overlay-transparent"
              >
                View more
                <v-icon class="ml-2">mdi-arrow-right</v-icon>
              </v-btn>
            </v-card-actions>
            <v-card-actions  v-else class="justify-center">
              <div>
                <a
                :href="getSupportSiteUrl(true) + '?ref=aibot'"
                color="primary"
                target="_blank"
              >
              Visit our Support site
              </a>
              for assistance.
              </div>
            </v-card-actions>
          </v-card>
        </v-card>

        <v-card
          v-if="isWealthRabbit"
          class="rounded-lg mt-4"
          elevation="1"
          v-for="(item, i) in feeds"
          :key="i"
          @click="redirectToSupportSite(item)"
        >
          <v-img cover :src="item.image"> </v-img>

          <v-card-text class="pa-4 card-bot-hover">
            <div class="fs-16px font-weight-medium text-tertiary">
              {{item.title}}
            </div>
            <div
              class="fs-14px text-black mt-2 img-w-100 d-inline-block"
              v-html="item.description"
            ></div>
          </v-card-text>
        </v-card>

        <v-card
          v-if="!isFeedAvailable"
          class="text-center pa-4 overflow-visible rounded-lg mt-4"
        >
          <v-card-text class="letter-spacing-0">
            <v-img
              alt="Business not Found"
              src="../../assets/images/no-data.svg"
              max-width="120px"
              height="200"
              class="mx-auto mt-4"
            ></v-img>
            <div class="text-h6 mt-4">No Feeds Available</div>
          </v-card-text>
        </v-card>
        
      </div>
      <div v-else>
        <SkeletonLoader type="image, article"></SkeletonLoader>
      </div>
    </v-card-text>
  </v-card>
</v-container>
